import { FeatureFlags } from '@domain/types';
import { useNetworkConnectionDetector } from '@hooks/useNetworkConnectionDetector.hook';
import { useFeatureFlags } from '@launcher/context/FeatureFlags.context';
import { tracking } from '@services/analytics';
import { message } from 'antd';
import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const BAD_CONNECTION_WARNING_LAST_DISPLAY_AT_KEY = 'BAD_CONNECTION_WARNING_LAST_DISPLAY_AT';
const LAST_DISPLAY_INTERVAL = 30 * 60 * 1000; // 30 minutes
const DISPLAY_ERROR_MESSAGE_INTERVAL = 10 * 60 * 1000; // 10 minutes

export const BadConnexionWarning = () => {
  const flags: FeatureFlags = useFeatureFlags();
  const threshold: number = flags['cafe-bad-connection-message'] || 0;
  const { t } = useTranslation();
  const ref = useRef<any>(undefined);

  const onChange = useCallback((payload: { status: string; downlink: number }) => {
    if (payload.status === 'bad') {
      const displayErrorMessage = () => {
        const lastDisplayedAt = new Date(
          localStorage.getItem(BAD_CONNECTION_WARNING_LAST_DISPLAY_AT_KEY) || 0,
        ).getTime();
        if (lastDisplayedAt > Date.now() - LAST_DISPLAY_INTERVAL) {
          // 30 minutes
          return;
        }

        tracking.trackNetworkConnection(payload.downlink);
        localStorage.setItem('BAD_CONNECTION_WARNING_LAST_DISPLAY_AT', new Date().toISOString());

        message.warning({
          content: t('info.message.badConnection'),
          duration: 10,
        });
      };

      ref.current = setInterval(displayErrorMessage, DISPLAY_ERROR_MESSAGE_INTERVAL);
      displayErrorMessage();
    } else {
      clearInterval(ref.current);
    }
  }, []);

  useNetworkConnectionDetector(threshold, onChange);
  useEffect(() => {
    const downlink = navigator?.connection?.downlink;
    if (downlink) {
      tracking.trackNetworkConnection(downlink * 1000);
    }
  }, []);

  return null;
};
